import React, { useEffect, useState } from 'react'
import useTrans from '@hooks/useTrans'
import useUtente from '@hooks/useUtente'
import { RequestType } from '@components/organisms/FormContattaci/FormContattaci.interfaces'
import { Button, HeaderBox, LoaderOverlay, StepBar, WContainer } from 'components/atoms'
import { FormLogin } from '@components/organisms'
import { AskRegistrationCard } from '@components/molecules'
import { AltreInformazioni, DatiRichiesta, MotivoRichiesta } from './steps/index'
import ModalFeedback from '@components/organisms/ModalFeedback/ModalFeedback'
import styles from './FormContattaci.module.sass'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'

const RenderSteps = ({
  registered,
  steps,
  setSteps,
  requestType,
  setRequestType,
  purposes,
  setPurposes,
  purposeArea,
  setPurposeArea,
}) => {
  switch (steps) {
    case 0:
      return (
        <MotivoRichiesta
          registered={registered}
          setSteps={setSteps}
          setRequestType={setRequestType}
          setPurposes={setPurposes}
          setPurposeArea={setPurposeArea}
        />
      )
    case 1:
      return requestType === RequestType.case1 ? (
        <AltreInformazioni
          registered={registered}
          setSteps={setSteps}
          setRequestType={setRequestType}
        />
      ) : (
        <DatiRichiesta
          registered={registered}
          requestType={requestType}
          purposes={purposes}
          purposeArea={purposeArea}
          setSteps={setSteps}
        />
      )
    default:
      return (
        <DatiRichiesta
          registered={registered}
          requestType={requestType}
          purposes={purposes}
          purposeArea={purposeArea}
          setSteps={setSteps}
        />
      )
  }
}

const FormContattaci = ({ initialStep }: { initialStep?: number | any }) => {
  const t = useTrans()
  const { utente } = useSelector((state) => state.utente)
  const nextPage = '/contatti'

  const [steps, setSteps] = useState(initialStep || 0)
  const [openLogin, setOpenLogin] = useState(false)
  const [noAccount, setNoAccount] = useState(false)
  const [requestType, setRequestType] = useState<RequestType>()
  const [purposes, setPurposes] = useState([])
  const [purposeArea, setPurposeArea] = useState('')
  const [showInfoModal, setShowInfoModal] = useState(false)
  const router = useRouter()

  const stepsItems = [
    t('Motivo della richiesta'),
    ...(requestType === RequestType.case1 ? [t('Altre informazioni')] : []),
    t('Dati della richiesta'),
    ...(!utente ? [t('Dati personali')] : []),
  ]

  const shouldShowLogin =
    !utente && !noAccount && (router.query.skip === 'false' || typeof router.query.skip === 'undefined')

  useEffect(() => {
    if (!shouldShowLogin && router.pathname === '/contatti') {
      setShowInfoModal(true)
    }
  }, [shouldShowLogin, router.pathname])

  return shouldShowLogin ? (
    <>
      <div className={styles.desktop}>
        <WContainer variant="xs">
          <div className={styles.container}>
            <HeaderBox
              title={t('Ho un account Danone')}
              classNameHeader={styles.header}
              classNameTitle={styles.title}
            />
            <FormLogin nextPage={nextPage} from="/contatti" />
          </div>
        </WContainer>
        <AskRegistrationCard onClick={() => setNoAccount(true)} />
      </div>
      <div className={styles.mobile}>
        {openLogin ? (
          <FormLogin nextPage={nextPage} from="/contatti" />
        ) : (
          <Button
            label="Accedi a Danone"
            onClick={() => setOpenLogin(true)}
            className={styles.submit}
          />
        )}
        <AskRegistrationCard
          className={styles.mobileButtons}
          showButton={!openLogin}
          onClick={() => setNoAccount(true)}
        />
      </div>
    </>
  ) : (
    <div className={styles.steps}>
      <ModalFeedback
        open={showInfoModal}
        title={t('RICHIAMO PRECAUZIONALE LATTI')}
        setOpen={setShowInfoModal}
        closeButton
        showIcon={false}
        description={
          <ul>
            <li>
              <strong>
                {t('Se apri il reclamo relativo al richiamo precauzionale dei Latti Aptamil e Mellin')}
              </strong>
              {t(', compila i dati richiesti inserendo con precisione:')}
            </li>
            <li>
              {t('a) Il motivo del contatto, selezionando la voce "Ingredienti ed Allergeni".')}
            </li>
            <li>{t('b) Il Codice EAN del prodotto.')}</li>
            <li>{t('c) Il Codice Lotto.')}</li>
            <li>{t('d) Carica la foto del prodotto con evidenza di LOTTO e SCADENZA.')}</li>
            <li>{t("e) Dove hai effettuato l'acquisto.")}</li>
          </ul>
        }
      />
      <StepBar activeStepIndex={steps + 1} steps={stepsItems} className={styles.stepbar} />
      <div className={styles.box}>
        <RenderSteps
          registered={Boolean(utente)}
          steps={steps}
          setSteps={setSteps}
          requestType={requestType}
          setRequestType={setRequestType}
          purposes={purposes}
          setPurposes={setPurposes}
          purposeArea={purposeArea}
          setPurposeArea={setPurposeArea}
        />
      </div>
    </div>
  )
}

export default FormContattaci
